import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { Template } from './templateStore.type';
import { TemplateType } from '@/types/global';

const InitialState = {
  footerConfigurationHeight: 0,
  type: 'sign',
};

const useTemplateStore = create<Template>()(
  devtools(set => ({
    data: InitialState,
    actions: {
      setFooterConfigurationHeight: (height: number) =>
        set(store => ({ ...store, data: { ...store.data, footerConfigurationHeight: height } })),
      setTemplateType: (type: TemplateType) => set(store => ({ ...store, data: { ...store.data, type } })),
    },
  })),
);

export default useTemplateStore;
